import axios from 'axios';
import { parseErrorMessages } from "../utils/ErrorUtils";

export const uploadData = async (
  apiEndpoint: string,
  formData: FormData,
  resetValues: () => void,
  setIsUploading: (value: boolean) => void,
  setAlertMessage: (message: string | null) => void,
  setAlertSeverity: (severity: 'success' | 'error' | 'info' | 'warning') => void,
  successMessage: string,
  errorMessagePrefix: string,
  showSuccess: (msg?: string) => void,
  showError: (msg?: string, fullErrors?: string[]) => void,
  onWaveRunning?: (waveData: any) => void
) => {
  console.log('Endpoint called is:', apiEndpoint);
  setIsUploading(true);
  try {
    const response = await axios.post(apiEndpoint || '', formData);
    console.log('Response:', response);
    if (response.status === 200) {
      if (response.data && response.data.waveStatusApiResponseList && onWaveRunning) {
        // If wave list is present, call the callback
        onWaveRunning(response.data);
      } else {
        // If no wave is running, treat as a direct success
        showSuccess(successMessage);
        resetValues();
      }
    } else {
      const errorMessage = `${errorMessagePrefix}: ${response.data.message || response.data}`;
      const parsedErrors = parseErrorMessages(response.data.message || response.data);
      // Pass parsed errors if there are multiple error lines or if parsing found multiple errors
      const shouldShowFullErrors = parsedErrors.length > 1 || parsedErrors.some(e => 
        /^Error.*line/i.test(e) || 
        /error.*line/i.test(e) || 
        /^.*\.(csv|txt):/i.test(e)
      );
      if (shouldShowFullErrors) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    }
  } catch (err: any) {
    console.log('Error:', err);
    if (err.response) {
      const errorMessage = `${errorMessagePrefix}: ${err.response.data.message || err.response.data}`;
      const parsedErrors = parseErrorMessages(err.response.data.message || err.response.data);
      // Pass parsed errors if there are multiple error lines or if parsing found multiple errors
      const shouldShowFullErrors = parsedErrors.length > 1 || parsedErrors.some(e => 
        /^Error.*line/i.test(e) || 
        /error.*line/i.test(e) || 
        /^.*\.(csv|txt):/i.test(e)
      );
      if (shouldShowFullErrors) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    } else if (err.request) {
      showError(`${errorMessagePrefix}: No response received`);
    } else {
      showError(`${errorMessagePrefix}: ${err.message}`);
    }
  } finally {
    setIsUploading(false);
  }
};